import React, { useEffect } from 'react';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import { navigate } from 'gatsby-link';
import themeSettings from '../utils/themeSettings';
// eslint-disable-next-line import/no-named-as-default-member
import HubspotFormModal from './hubspotFormModal/HubspotFormModal';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const GlobalStyle = createGlobalStyle`

@font-face {
    font-family: 'Barlow';
    font-display: block;
    font-style: normal;
    font-weight: 200;
    src: url('/fonts/woff/barlow-v5-latin-ext-200.woff2') format('opentype');
}

@font-face {
    font-family: 'Barlow';
    font-display: block;
    font-style: normal;
    font-weight: 300;
    src: url('/fonts/woff/barlow-v5-latin-ext-300.woff2') format('opentype');
}
@font-face {
    font-family: 'Barlow';
    font-display: block;
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/woff/barlow-v5-latin-ext-regular.woff2') format('opentype');
}
@font-face {
    font-family: 'Barlow';
    font-display: block;
    font-style: normal;
    font-weight: 500;
    src: url('/fonts/woff/barlow-v5-latin-ext-500.woff2') format('opentype');
}
@font-face {
    font-family: 'Barlow';
    font-display: block;
    font-style: normal;
    font-weight: 700;
    src: url('/fonts/woff/barlow-v5-latin-ext-700.woff2') format('opentype');
}
@font-face {
    font-family: 'Barlow';
    font-display: block;
    font-style: normal;
    font-weight: 800;
    src: url('/fonts/woff/barlow-v5-latin-ext-800.woff2') format('opentype');
}

html {
	overflow-y: ${props => (props.isMobileMenuVisible || props.isHubspotFormVisible ? 'hidden' : 'auto')};
	overflow-x: hidden;
}
body {
	width: 100%;
	padding: 0;
	margin: 0;
	overflow: hidden;
	font-family: ${({ theme }) => theme.fontFamily.mainFont};
	background-color: white;
	-webkit-tap-highlight-color: transparent;
}

button {
	font-family: ${({ theme }) => theme.fontFamily.mainFont};
&:focus {
	outline: none;
}
}

a {
&:focus {
		outline: none;
	}
}

*, *::before, *::after{
	box-sizing: border-box;
}


*::placeholder {
	font-family: ${({ theme }) => theme.fontFamily.mainFont};
}

h1, h2, h3, h4, h5, h6 {
	margin: 0;
	padding: 0;
}

p {
	margin: 0;
	padding: 0;
}

ul {
	list-style-type: none;
	padding: 0;
	margin: 0;
}
`;

const StyledWrapper = styled.div`
	background-image: linear-gradient(to bottom, transparent 100px, white 0);
	margin: 0 auto;
	max-width: 100vw;
`;

const Layout = ({ children, isMobileMenuVisible, isHubspotFormVisible, pageContext }) => {
	const currentLocale = pageContext?.locale;
	useEffect(() => {
		const language = window?.navigator?.language || '';
		if (!language.includes('pl')) {
			navigate('/en');
		}
	}, []);
	return (
		<ThemeProvider theme={themeSettings}>
			<>
				<GlobalStyle isMobileMenuVisible={isMobileMenuVisible} isHubspotFormVisible={isHubspotFormVisible} />
				<StyledWrapper>{children}</StyledWrapper>
				{isHubspotFormVisible && <HubspotFormModal currentLocale={currentLocale} />}
			</>
		</ThemeProvider>
	);
};

export default connect(
	state => ({
		isMobileMenuVisible: state.app.isMobileMenuVisible,
		isHubspotFormVisible: state.app.isHubspotFormVisible,
	}),
	null,
)(Layout);
